import { message, Select, Tag } from 'antd';
import React, { useEffect, useState } from 'react';

import { fetchAPI } from '../../utils/api';
import { OrderPaymentStatus } from './OrderListV2/types';
import { ColorMap } from './utils';

const OrderPaymentStatusDropdown = (props: {
  record: { id: number; payment_status: string };
  hideMLabel?: boolean;
  refreshList?: () => Promise<void>;
}) => {
  const [values, setValues] = useState({
    real: null,
    temp: null,
  });
  const [loading, setLoading] = useState(false);

  const changePaymentStatus = async value => {
    setValues(val => ({ ...val, temp: value }));
    setLoading(true);
    try {
      await fetchAPI(`orders/${props.record.id}/set-payment_status`, {
        method: 'POST',
        payload: {
          payment_status: value,
        },
      });
      setValues({ real: value, temp: value });
      if (props.refreshList) {
        await props.refreshList();
      }
    } catch (error) {
      message.error('Failed change payment status');
      message.error(error.message || 'Error');
      setValues(val => ({ ...val, temp: val.real }));
    }
    setLoading(false);
  };

  useEffect(() => {
    setValues({
      real: props.record.payment_status,
      temp: props.record.payment_status,
    });
  }, [props.record.id, props.record.payment_status]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {!props.hideMLabel && <span className="m-label">Payment Status</span>}
      <Select
        value={values.temp}
        onChange={value => changePaymentStatus(value)}
        loading={loading}
        disabled={loading || !props.record?.id}
      >
        {Object.values(OrderPaymentStatus).map((str, idx) => (
          <Select.Option value={str} key={`${str}-${idx}`}>
            <OrderPaymentStatusTag paymentStatus={str} />
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export const OrderPaymentStatusTag = (props: { paymentStatus: string }) => {
  if (props.paymentStatus === OrderPaymentStatus.PARTIALLY_PAID) {
    return (
      <Tag
        style={{
          borderColor: '#808000',
          backgroundColor: '#f0f5e0', // lighter version of #808000
          color: '#808000',
          fontSize: 10,
        }}
      >
        {props.paymentStatus}
      </Tag>
    );
  }

  return (
    <Tag color={ColorMap[props.paymentStatus]} style={{ fontSize: 10 }}>
      {props.paymentStatus}
    </Tag>
  );
};

export default OrderPaymentStatusDropdown;
